var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import React, { useRef, useState } from "react";
import Common_Shimmer from "@frameworks/shared-library/components/common_shimmer";
import GenericSidebar from "@frameworks/shared-library/components/GenericSidebar";
import Edelicon from "@frameworks/shared-library/components/Generic/Edelicon";
import GenericSchemeName from "@frameworks/shared-library/components/GenericSchemeName/GenericSchemeName";
import GenericStatus from "@frameworks/shared-library/components/GenericStatus/GenericStatus";
import loginDI from "@frameworks/salesjourney/components/Login/di/index";
import apiFailure from "@frameworks/shared-library/assets/images/SalesJourney/api-failure.svg";
import autheticate from "@frameworks/shared-library/assets/images/SalesJourney/autheticate.svg";
import esignLink from "@frameworks/shared-library/assets/images/SalesJourney/send-esign-link.svg";
import selfieLink from "@frameworks/shared-library/assets/images/SalesJourney/send-selfie-link.svg";
import successIcon from "@frameworks/shared-library/assets/images/SalesJourney/success-circular-icon.svg";
import failureIcon from "@frameworks/shared-library/assets/images/SalesJourney/failure-icon.svg";
import Errormsg from "@frameworks/shared-library/components/errorMsg";
import applicationDetails from "@frameworks/shared-library/assets/images/generic/applicationDetails.svg";
import qualityCheck from "@frameworks/shared-library/assets/images/generic/qualityCheck.svg";
import GenericTimeline, { ETimelineState, } from "@frameworks/shared-library/components/GenericTimeline/GenericTimeline";
import customerKYCDetails from "@frameworks/shared-library/assets/images/generic/customerKYCDetails.svg";
import { Spinner } from "react-bootstrap";
import { base64toPDF } from "@domains/utils/fileMethods";
import aopOrderBookDI from "./di/servicelocator";
import leadDI from "@frameworks/salesjourney/components/Features/LeadDashboard/di/serviceLocator";
import Toasts from "@frameworks/shared-library/components/Toast/Toast";
import { getDateInFormat } from "@domains/utils/reportDates";
import { toCamelCase } from "@domains/utils/stringMethods";
import AOPOrderbookNeedHelp from "./AOP_Need_Help";
var AOPSidebar = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
    var _x = __read(useState(false), 2), openTimeline = _x[0], setOpenTimeline = _x[1];
    var _y = __read(React.useState(false), 2), loader = _y[0], setLoader = _y[1];
    var _z = __read(React.useState(false), 2), errorFoundMain = _z[0], setErrorFoundMain = _z[1];
    var _0 = __read(useState({
        isShow: false,
        isError: false,
        msg: "",
    }), 2), toastDetails = _0[0], setToastDetails = _0[1];
    var _1 = __read(useState({
        isShow: false,
        isError: false,
        msg: "",
    }), 2), esignToastDetails = _1[0], setEsignToastDetails = _1[1];
    var _2 = __read(useState({
        isShow: false,
        isError: false,
        msg: "",
    }), 2), selfieToastDetails = _2[0], setSelfieToastDetails = _2[1];
    var _3 = __read(useState({
        isShow: false,
        isError: false,
        msg: "",
    }), 2), verificationLinkToastDetails = _3[0], setVerificationLinkToastDetails = _3[1];
    var _4 = __read(React.useState(null), 2), aopOrderBookSideBar = _4[0], setAOPOrderBookSideBarData = _4[1];
    var _5 = __read(React.useState(false), 2), downloadSpinner = _5[0], setDownloadSpinner = _5[1];
    var _6 = __read(React.useState(""), 2), leadRedirectinURL = _6[0], setLeadRedirectionURL = _6[1];
    var _7 = __read(React.useState(false), 2), overlaySpinner = _7[0], setOverlaySpinner = _7[1];
    var _8 = __read(React.useState({
        isShowPopup: false,
        containerId: "",
    }), 2), moreActionPopupConfig = _8[0], setMoreActionPopupConfig = _8[1];
    var _9 = __read(React.useState(false), 2), showPopupMenu = _9[0], setShowPopupMenu = _9[1];
    var _10 = __read(useState([]), 2), timelineDetails = _10[0], setTimelineDetails = _10[1];
    var _11 = __read(useState(0), 2), activeIndex = _11[0], setActiveIndex = _11[1];
    var togglePanel = function (index) {
        setActiveIndex(activeIndex === index ? null : index);
    };
    var componentRef = useRef(null);
    var sectionRef = useRef(null);
    var targetRef = useRef(null);
    // Function to scroll to the section
    var scrollToTop = function () {
        if (sectionRef.current) {
            sectionRef.current.scrollTop = 0;
        }
    };
    var scrollToBottom = function () {
        if (sectionRef.current) {
            sectionRef.current.scrollTop = sectionRef.current.scrollHeight;
        }
    };
    // Scroll to a specific element within the scrollable container
    var scrollToElement = function () {
        if (targetRef.current) {
            targetRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };
    var getQCAssignedTo = function () {
        var _a, _b, _c, _d, _e;
        var finalText = "-";
        if (!!((_a = aopOrderBookSideBar === null || aopOrderBookSideBar === void 0 ? void 0 : aopOrderBookSideBar.quality_check_details) === null || _a === void 0 ? void 0 : _a.qc_assigned_to) &&
            ((_b = aopOrderBookSideBar === null || aopOrderBookSideBar === void 0 ? void 0 : aopOrderBookSideBar.quality_check_details) === null || _b === void 0 ? void 0 : _b.qc_assigned_to) !== "") {
            var qcDate = "-";
            if (!!((_c = aopOrderBookSideBar === null || aopOrderBookSideBar === void 0 ? void 0 : aopOrderBookSideBar.quality_check_details) === null || _c === void 0 ? void 0 : _c.qc_submit_dt) &&
                ((_d = aopOrderBookSideBar === null || aopOrderBookSideBar === void 0 ? void 0 : aopOrderBookSideBar.quality_check_details) === null || _d === void 0 ? void 0 : _d.qc_submit_dt) !== "") {
                qcDate = getDateInFormat((_e = aopOrderBookSideBar === null || aopOrderBookSideBar === void 0 ? void 0 : aopOrderBookSideBar.quality_check_details) === null || _e === void 0 ? void 0 : _e.qc_submit_dt, "DD/MM/YY");
            }
            finalText =
                aopOrderBookSideBar.quality_check_details.qc_assigned_to +
                    "(" +
                    qcDate +
                    ")";
        }
        return finalText;
    };
    var disabledRestartApplication = function () {
        var _a;
        var buttonDisabled = false;
        var qcApprovedIndex = (_a = aopOrderBookSideBar === null || aopOrderBookSideBar === void 0 ? void 0 : aopOrderBookSideBar.order_details) === null || _a === void 0 ? void 0 : _a.findIndex(function (record) {
            return (record.stageid == 150 && (record === null || record === void 0 ? void 0 : record.iscompleted)) ||
                (record.stageid == 400 && (record === null || record === void 0 ? void 0 : record.iscompleted));
        });
        if (qcApprovedIndex > 0) {
            buttonDisabled = true;
        }
        return buttonDisabled;
    };
    var showThreeDots = function () {
        var _a, _b;
        var showThree = false;
        if (((_a = aopOrderBookSideBar === null || aopOrderBookSideBar === void 0 ? void 0 : aopOrderBookSideBar.application_details) === null || _a === void 0 ? void 0 : _a.isselfielinkdisable) ||
            ((_b = aopOrderBookSideBar === null || aopOrderBookSideBar === void 0 ? void 0 : aopOrderBookSideBar.application_details) === null || _b === void 0 ? void 0 : _b.isauthlinkdisable)) {
            showThree = true;
        }
        return showThree;
    };
    var getOrderTimeline = function () {
        return (React.createElement("div", { className: "ob-timeline-container" },
            React.createElement(EdButton, { btnTyp: "text-only", onClick: function () { return setOpenTimeline(!openTimeline); }, className: "DMSansNormal_12_400", value: React.createElement("span", { className: "d-flex align-items-center gap-1" },
                    React.createElement("span", { className: "text-decoration-underline" }, "Order Timeline"),
                    React.createElement("i", { className: openTimeline
                            ? "edel-icon-arrow-up-thin"
                            : "edel-icon-arrow-down" })) }),
            openTimeline && (React.createElement("div", { className: "ob-timeline-content" }, !Boolean(timelineDetails) ? (React.createElement(Errormsg, { icon: " ", msg: " ", customComp: React.createElement("div", { className: "error-state-button-bar flexCenter" },
                    React.createElement("p", { className: "DMSanN_14_400" }, "No Timeline data found")) })) : // If timelineDetails has content - display timeline
                (timelineDetails === null || timelineDetails === void 0 ? void 0 : timelineDetails.length) > 0 ? (React.createElement(GenericTimeline, { timelineDetails: timelineDetails })) : (
                // If get timelineDetails throw an error
                React.createElement(Errormsg, { icon: " ", msg: "  ", customComp: React.createElement("div", { className: "error-state-button-bar flexCenter" },
                        React.createElement("p", { className: "DMSanN_14_400" }, "Try refreshing page, or try again later"),
                        React.createElement("button", { className: "align-items-center DMSanN_13_500", onClick: function () { } }, "Try Again")) }))))));
    };
    var showFooter = function () {
        return true;
    };
    var displayDash = function (orderBook) {
        var value = "-";
        if (typeof orderBook == "string" && !!orderBook && orderBook !== "")
            value = orderBook;
        if (typeof orderBook == "number" && !!orderBook && orderBook !== 0) {
            value = orderBook;
        }
        return value;
    };
    var outSideClick = function () {
        setShowPopupMenu(false);
    };
    var onButtonClick = function (event) {
        if (leadRedirectinURL !== null &&
            leadRedirectinURL !== undefined &&
            leadRedirectinURL !== "")
            window.open(leadRedirectinURL, "_blank", "noopener,noreferrer");
    };
    var getAOPOrderBookSideBar = function () {
        var _a;
        setLoader(true);
        setTimelineDetails([]);
        var reqObj = {
            applicationId: (_a = props === null || props === void 0 ? void 0 : props.selectedRowObj) === null || _a === void 0 ? void 0 : _a.accountCode,
            encryption: true,
        };
        aopOrderBookDI.aopOrderBook
            .getApplicationDetails(reqObj)
            .then(function (resp) {
            var _a, _b, _c, _d, _e, _f;
            if (resp == null || resp == undefined) {
                setErrorFoundMain(true);
            }
            else {
                setErrorFoundMain(false);
                setAOPOrderBookSideBarData(resp);
                if (!!resp &&
                    !!(resp === null || resp === void 0 ? void 0 : resp.application_details) &&
                    !!((_a = resp === null || resp === void 0 ? void 0 : resp.application_details) === null || _a === void 0 ? void 0 : _a.leadid) &&
                    ((_b = resp === null || resp === void 0 ? void 0 : resp.application_details) === null || _b === void 0 ? void 0 : _b.leadid) !== "") {
                    getViewLeadDetails((_c = resp === null || resp === void 0 ? void 0 : resp.application_details) === null || _c === void 0 ? void 0 : _c.leadid);
                }
                setMoreActionPopupConfig(__assign(__assign({}, moreActionPopupConfig), { containerId: (_d = props === null || props === void 0 ? void 0 : props.selectedRowObj) === null || _d === void 0 ? void 0 : _d.accountCode }));
                if (!!resp &&
                    !!(resp === null || resp === void 0 ? void 0 : resp.order_details) &&
                    ((_e = resp === null || resp === void 0 ? void 0 : resp.order_details) === null || _e === void 0 ? void 0 : _e.length) > 0) {
                    var orderDetails = resp === null || resp === void 0 ? void 0 : resp.order_details, anotherOrderDetails_1 = resp === null || resp === void 0 ? void 0 : resp.order_details;
                    if (((_f = props === null || props === void 0 ? void 0 : props.selectedRowObj) === null || _f === void 0 ? void 0 : _f.kycStatus) == "KRA") {
                        var orderDetailsIndex = orderDetails.findIndex(function (record) { return record.stageid == 128; });
                        if (orderDetailsIndex > 0)
                            orderDetails.splice(orderDetailsIndex, 1);
                        anotherOrderDetails_1 = orderDetails;
                    }
                    var timeLineEvents_1 = [];
                    orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.map(function (resp1, index) {
                        if (resp1.iscompleted) {
                            var status_1, name_1 = "";
                            var description = getDateInFormat(resp1.stagecompletedate, "DD MMM YY,  hh:mm:ss A");
                            // Handle failed stages (151 or 404)
                            if (resp1.stageid == 151 || resp1.stageid == 404) {
                                status_1 = ETimelineState.FAILED;
                            }
                            // Handle "Account Opened Successfully" stage (stageid 400)
                            // else if (resp1.stageid == 400) {
                            //   name = "Account Opened Successfully";
                            //   status = ETimelineState.COMPLETED;
                            // }
                            // Handle other stages
                            else {
                                // Check if the stage is already in progress
                                var inProgressIndex = timeLineEvents_1.findIndex(function (resp) {
                                    return resp.header.toLowerCase() ==
                                        resp1.stagename.toLowerCase() &&
                                        resp.status == ETimelineState.IN_PROGRESS;
                                });
                                if (inProgressIndex > -1) {
                                    timeLineEvents_1[inProgressIndex].status =
                                        ETimelineState.COMPLETED;
                                    timeLineEvents_1[inProgressIndex].description = description;
                                    if (index + 1 < (anotherOrderDetails_1 === null || anotherOrderDetails_1 === void 0 ? void 0 : anotherOrderDetails_1.length)) {
                                        var nextStage = anotherOrderDetails_1 === null || anotherOrderDetails_1 === void 0 ? void 0 : anotherOrderDetails_1[index + 1];
                                        if (![151, 404, 400].includes(nextStage === null || nextStage === void 0 ? void 0 : nextStage.stageid)) {
                                            timeLineEvents_1.push({
                                                header: nextStage.stagename,
                                                status: ETimelineState.IN_PROGRESS,
                                            });
                                        }
                                    }
                                    return;
                                }
                                else {
                                    status_1 = ETimelineState.COMPLETED;
                                }
                            }
                            timeLineEvents_1.push({
                                header: !!name_1 && name_1 !== "" ? name_1 : resp1.stagename,
                                status: status_1,
                                description: description,
                            });
                            // Handle the next stage if it's not the last one
                            if (!!status_1 &&
                                status_1 !== ETimelineState.FAILED &&
                                index + 1 < (anotherOrderDetails_1 === null || anotherOrderDetails_1 === void 0 ? void 0 : anotherOrderDetails_1.length)) {
                                var nextStage = anotherOrderDetails_1 === null || anotherOrderDetails_1 === void 0 ? void 0 : anotherOrderDetails_1[index + 1];
                                if (![151, 404, 400].includes(nextStage === null || nextStage === void 0 ? void 0 : nextStage.stageid)) {
                                    timeLineEvents_1.push({
                                        header: nextStage.stagename,
                                        status: ETimelineState.IN_PROGRESS,
                                    });
                                }
                            }
                        }
                        else {
                            // If the stage is not completed, ensure it gets marked as "unreached"
                            var inProgressIndex = timeLineEvents_1.findIndex(function (resp) {
                                return resp.header.toLowerCase() ==
                                    resp1.stagename.toLowerCase() &&
                                    resp.status == ETimelineState.IN_PROGRESS;
                            });
                            if (inProgressIndex <= 0 &&
                                resp1.stageid != 400 &&
                                resp1.stageid !== 404) {
                                timeLineEvents_1.push({
                                    header: resp1.stagename,
                                    status: ETimelineState.UNREACHED,
                                });
                            }
                            else if (resp1.stageid == 404) {
                                timeLineEvents_1.push({
                                    header: resp1.stagename,
                                    status: ETimelineState.FAILED,
                                });
                            }
                            else if (resp1.stageid == 400) {
                                timeLineEvents_1.push({
                                    header: resp1.stagename,
                                    status: ETimelineState.UNREACHED,
                                });
                            }
                        }
                    });
                    setTimelineDetails(timeLineEvents_1);
                }
            }
            setLoader(false);
        })
            .catch(function () {
            setAOPOrderBookSideBarData(null);
            setErrorFoundMain(true);
            setLoader(false);
        });
    };
    var getAOPOrderBookKYCDocument = function () {
        var _a;
        setToastDetails({ isShow: false, isError: false, msg: "" });
        setDownloadSpinner(true);
        var reqObj = {
            applicationId: (_a = props === null || props === void 0 ? void 0 : props.selectedRowObj) === null || _a === void 0 ? void 0 : _a.accountCode,
            accountCategory: 2,
            isKYCDownload: true,
            encryption: true,
        };
        aopOrderBookDI.aopOrderBook
            .getAopOrderBookGetKyc(reqObj)
            .then(function (resp) {
            var _a;
            if (!!resp && !!(resp === null || resp === void 0 ? void 0 : resp.data) && (resp === null || resp === void 0 ? void 0 : resp.data) !== "") {
                setToastDetails({
                    isShow: true,
                    isError: false,
                    msg: "Form Downloaded Successfully.",
                });
                setDownloadSpinner(false);
                base64toPDF(resp.data, "KYC_Data_" + ((_a = props === null || props === void 0 ? void 0 : props.selectedRowObj) === null || _a === void 0 ? void 0 : _a.accountCode) + ".pdf");
            }
        })
            .catch(function (resp) {
            setToastDetails({
                isShow: true,
                isError: true,
                msg: "The form download failed. Please try again.",
            });
            setDownloadSpinner(false);
        });
    };
    var sendEsignLink = function () {
        var _a;
        setEsignToastDetails({ isShow: false, isError: false, msg: "" });
        setOverlaySpinner(true);
        var reqObj = {
            applicationId: (_a = props === null || props === void 0 ? void 0 : props.selectedRowObj) === null || _a === void 0 ? void 0 : _a.accountCode,
            encryption: true,
        };
        aopOrderBookDI.aopOrderBook
            .getAopOrderBookESignLink(reqObj)
            .then(function (resp) {
            setEsignToastDetails({
                isShow: true,
                isError: false,
                msg: "Esign link has been successfully sent.",
            });
            // setMoreActionPopupConfig({
            //   isShowPopup: false,
            //   containerId: "",
            // });
            setShowPopupMenu(false);
            setOverlaySpinner(false);
        })
            .catch(function (resp) {
            setEsignToastDetails({
                isShow: true,
                isError: false,
                msg: "Oops! there was an error sending the esign link.Please try again later.",
            });
            // setMoreActionPopupConfig({
            //   isShowPopup: false,
            //   containerId: "",
            // });
            setShowPopupMenu(false);
            setOverlaySpinner(false);
        });
    };
    var sendSelfieLink = function () {
        var _a;
        setSelfieToastDetails({ isShow: false, isError: false, msg: "" });
        setOverlaySpinner(true);
        var reqObj = {
            applicationId: (_a = props === null || props === void 0 ? void 0 : props.selectedRowObj) === null || _a === void 0 ? void 0 : _a.accountCode,
            encryption: true,
        };
        aopOrderBookDI.aopOrderBook
            .getAopOrderbookSelfieLink(reqObj)
            .then(function (resp) {
            setSelfieToastDetails({
                isShow: true,
                isError: false,
                msg: "Selfie link has been successfully sent.",
            });
            // setMoreActionPopupConfig({
            //   isShowPopup: false,
            //   containerId: "",
            // });
            setShowPopupMenu(false);
            setOverlaySpinner(false);
        })
            .catch(function (resp) {
            setSelfieToastDetails({
                isShow: true,
                isError: false,
                msg: "Oops! there was an error sending the selfie link.Please try again later.",
            });
            // setMoreActionPopupConfig({
            //   isShowPopup: false,
            //   containerId: "",
            // });
            setShowPopupMenu(false);
            setOverlaySpinner(false);
        });
    };
    var sendVerificationLink = function () {
        var _a;
        setVerificationLinkToastDetails({ isShow: false, isError: false, msg: "" });
        setOverlaySpinner(true);
        var reqObj = {
            applicationId: (_a = props === null || props === void 0 ? void 0 : props.selectedRowObj) === null || _a === void 0 ? void 0 : _a.accountCode,
            encryption: true,
        };
        aopOrderBookDI.aopOrderBook
            .getAopOrderbookVerificationLink(reqObj)
            .then(function (resp) {
            setVerificationLinkToastDetails({
                isShow: true,
                isError: false,
                msg: "Verification link has been successfully sent.",
            });
            // setMoreActionPopupConfig({
            //   isShowPopup: false,
            //   containerId: "",
            // });
            setShowPopupMenu(false);
            setOverlaySpinner(false);
        })
            .catch(function (resp) {
            setVerificationLinkToastDetails({
                isShow: true,
                isError: false,
                msg: "Oops! there was an error sending the Verification link.Please try again later.",
            });
            // setMoreActionPopupConfig({
            //   isShowPopup: false,
            //   containerId: "",
            // });
            setShowPopupMenu(false);
            setOverlaySpinner(false);
        });
    };
    var getOverLayUIContent = function () {
        var _a, _b, _c, _d, _e;
        return (React.createElement("div", { className: "overlay table-actions-without-generic-popup-container" },
            React.createElement("div", { className: "modal-content table-actions-internal-list-wrapper flex-column flexCenter" }, overlaySpinner ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "action-internal-item displayFlex align-self-start gap-10" },
                    React.createElement(Spinner, { animation: "border", variant: "primary", className: "txt_tomatoRed" })))) : (React.createElement(React.Fragment, null,
                ((_a = aopOrderBookSideBar === null || aopOrderBookSideBar === void 0 ? void 0 : aopOrderBookSideBar.application_details) === null || _a === void 0 ? void 0 : _a.isesignlinkdisable) && (React.createElement("div", { className: "action-internal-item displayFlex align-self-start gap-10 hand_cursor", key: "esign", tabIndex: 0, onClick: function (e) {
                        sendEsignLink();
                    } },
                    React.createElement("label", { className: "DMSanN_14_400 txt-han-blue hand_cursor" }, "Send Esign Link"))),
                ((_b = aopOrderBookSideBar === null || aopOrderBookSideBar === void 0 ? void 0 : aopOrderBookSideBar.application_details) === null || _b === void 0 ? void 0 : _b.isselfielinkdisable) && (React.createElement("div", { className: "action-internal-item displayFlex align-self-start gap-10 hand_cursor", key: "esign", tabIndex: 0, onClick: function (e) {
                        sendSelfieLink();
                    } },
                    React.createElement(React.Fragment, null,
                        React.createElement("img", { src: selfieLink })),
                    React.createElement("label", { className: "DMSanN_14_400 txt-han-blue hand_cursor" }, "Send Selfie Link"))),
                ((_c = aopOrderBookSideBar === null || aopOrderBookSideBar === void 0 ? void 0 : aopOrderBookSideBar.application_details) === null || _c === void 0 ? void 0 : _c.isauthlinkdisable) && (React.createElement("div", { className: "action-internal-item displayFlex align-self-start gap-10 hand_cursor", key: "esign", tabIndex: 0, onClick: function (e) {
                        sendVerificationLink();
                    } },
                    ((_d = props === null || props === void 0 ? void 0 : props.selectedRowObj) === null || _d === void 0 ? void 0 : _d.kycStatus) === "KRA" ? (React.createElement(React.Fragment, null,
                        React.createElement("img", { src: autheticate }))) : (React.createElement(React.Fragment, null,
                        React.createElement("img", { src: esignLink }))),
                    React.createElement("label", { className: "DMSanN_14_400 txt-han-blue hand_cursor" }, ((_e = props === null || props === void 0 ? void 0 : props.selectedRowObj) === null || _e === void 0 ? void 0 : _e.kycStatus) == "KRA"
                        ? "Send Authentication Link"
                        : "Send Esign Link"))))))));
    };
    var getViewLeadDetails = function (LeadId) {
        var payloads = {
            LeadId: LeadId,
        };
        leadDI.leads
            .getViewLeadData(payloads)
            .then(function (data) {
            var _a, _b, _c;
            if (!((_a = loginDI.login.getIsRMPartnerFRM()) === null || _a === void 0 ? void 0 : _a.isPartner) &&
                !!(data === null || data === void 0 ? void 0 : data.data) &&
                !!((_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.orderId) &&
                ((_c = data === null || data === void 0 ? void 0 : data.data) === null || _c === void 0 ? void 0 : _c.orderId)) {
                var redirectionUrl = "";
                leadRedirection(data === null || data === void 0 ? void 0 : data.data)
                    .then(function (resp) {
                    if (resp.url !== "" &&
                        (resp === null || resp === void 0 ? void 0 : resp.url) !== null &&
                        (resp === null || resp === void 0 ? void 0 : resp.url) !== undefined) {
                        //redirectionUrl = resp.data;
                        setLeadRedirectionURL(resp.url);
                    }
                    else {
                        setLeadRedirectionURL("");
                    }
                })
                    .catch(function (error) {
                    setLeadRedirectionURL("");
                });
            }
        })
            .catch(function (err) {
            setLeadRedirectionURL("");
        });
    };
    var leadRedirection = function (leadData) {
        var _a;
        var req = {
            leadId: leadData === null || leadData === void 0 ? void 0 : leadData.leadId,
            orderId: (_a = leadData === null || leadData === void 0 ? void 0 : leadData.orderId) === null || _a === void 0 ? void 0 : _a.toString(),
            leadSource: "SALESJOURNEY",
            email: leadData === null || leadData === void 0 ? void 0 : leadData.email,
            mobile: leadData === null || leadData === void 0 ? void 0 : leadData.mobile,
            product: leadData === null || leadData === void 0 ? void 0 : leadData.productId.toString(),
            category: leadData === null || leadData === void 0 ? void 0 : leadData.categoryId.toString(),
        };
        return leadDI.leads.getLeadRedirection(req);
    };
    React.useEffect(function () {
        getAOPOrderBookSideBar();
        var handleClickOutside = function (event) {
            // If the click is outside the component, close it
            if (componentRef.current &&
                !componentRef.current.contains(event.target)) {
                setShowPopupMenu(false);
            }
        };
        document.addEventListener("click", handleClickOutside);
        // Cleanup event listener when component unmounts
        return function () {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    var rerjectReasonsArrays = function () {
        var _a, _b, _c;
        var array = [];
        if (((_a = aopOrderBookSideBar === null || aopOrderBookSideBar === void 0 ? void 0 : aopOrderBookSideBar.application_details) === null || _a === void 0 ? void 0 : _a.rejectionreasons) !== "" &&
            !!((_b = aopOrderBookSideBar === null || aopOrderBookSideBar === void 0 ? void 0 : aopOrderBookSideBar.application_details) === null || _b === void 0 ? void 0 : _b.rejectionreasons)) {
            array = (_c = aopOrderBookSideBar === null || aopOrderBookSideBar === void 0 ? void 0 : aopOrderBookSideBar.application_details) === null || _c === void 0 ? void 0 : _c.rejectionreasons.split(",").map(function (item) { return item.trim(); });
        }
        return array;
    };
    var showRejectedDescription = function () {
        var _a;
        return (React.createElement("div", { className: "d-flex flex-column DMsanR_11_400" }, ((_a = rerjectReasonsArrays()) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
            rerjectReasonsArrays().map(function (itetm) {
                return (React.createElement("span", null,
                    " ",
                    React.createElement("i", { className: "edel-icon-round-circle" }),
                    React.createElement("label", { className: "rejection-reason-margin" },
                        toCamelCase(itetm),
                        " ")));
            })));
    };
    var getCustomIcon = function () {
        var _a;
        if (((_a = props === null || props === void 0 ? void 0 : props.selectedRowObj) === null || _a === void 0 ? void 0 : _a.displayStatus) == "Document Upload page completed")
            return React.createElement("i", { className: "edel-icon-round-circle mb-30" });
        return "";
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(GenericSidebar, { parentClassname: "aop-order-book-sidebar-container", parentIcon: "edel-icon-close", header: React.createElement("div", null,
                React.createElement("div", { className: "read-more-tooltip align-items-center" },
                    React.createElement(GenericSchemeName, { name: (_a = props === null || props === void 0 ? void 0 : props.selectedRowObj) === null || _a === void 0 ? void 0 : _a.clientName, subText1: ((_c = (_b = props === null || props === void 0 ? void 0 : props.selectedRowObj) === null || _b === void 0 ? void 0 : _b.accountCode) === null || _c === void 0 ? void 0 : _c.endsWith("I"))
                            ? (_e = (_d = props === null || props === void 0 ? void 0 : props.selectedRowObj) === null || _d === void 0 ? void 0 : _d.accountCode) === null || _e === void 0 ? void 0 : _e.slice(0, -1)
                            : (_f = props === null || props === void 0 ? void 0 : props.selectedRowObj) === null || _f === void 0 ? void 0 : _f.accountCode, 
                        // subText2={"SSSSS"}
                        maxWidth: 305, transactionType: "Investment Acount", showTooltip: true, showImage: true, wrap: true }))), body: React.createElement(React.Fragment, null,
                toastDetails && (React.createElement(Toasts, { show: toastDetails.isShow, setShow: function (val) {
                        setToastDetails({ isShow: val, isError: false, msg: "" });
                    }, position: "bottom-center", 
                    // message={toastDetails.msg}
                    customMessage: React.createElement(React.Fragment, null,
                        React.createElement("span", { className: "d-flex justify-content-between" },
                            React.createElement("span", { className: "d-flex" },
                                React.createElement("img", { src: toastDetails.isError ? failureIcon : successIcon }),
                                React.createElement("label", { className: "toast-custom-label" }, toastDetails === null || toastDetails === void 0 ? void 0 : toastDetails.msg)),
                            React.createElement("div", { className: "edel-icon" },
                                React.createElement(Edelicon, { className: "edel-icon-close cursor-pointer", onClick: function () {
                                        return setToastDetails({
                                            isShow: false,
                                            isError: false,
                                            msg: "",
                                        });
                                    } })))), delay: 3000, parentClass: "sidebar-toast-container ".concat(toastDetails.isError ? "error-toast" : "success-toast") })),
                esignToastDetails && (React.createElement(Toasts, { show: esignToastDetails.isShow, setShow: function (val) {
                        setEsignToastDetails({
                            isShow: val,
                            isError: false,
                            msg: "",
                        });
                    }, position: "bottom-center", 
                    // message={toastDetails.msg}
                    customMessage: React.createElement(React.Fragment, null,
                        React.createElement("span", { className: "d-flex justify-content-between" },
                            React.createElement("span", { className: "d-flex" },
                                React.createElement("img", { src: esignToastDetails.isError
                                        ? failureIcon
                                        : successIcon }),
                                React.createElement("label", { className: "toast-custom-label" }, esignToastDetails === null || esignToastDetails === void 0 ? void 0 : esignToastDetails.msg)),
                            React.createElement("div", { className: "edel-icon" },
                                React.createElement(Edelicon, { className: "edel-icon-close cursor-pointer", onClick: function () {
                                        return setEsignToastDetails({
                                            isShow: false,
                                            isError: false,
                                            msg: "",
                                        });
                                    } })))), delay: 3000, parentClass: "sidebar-toast-container ".concat(esignToastDetails.isError ? "error-toast" : "success-toast") })),
                selfieToastDetails && (React.createElement(Toasts, { show: selfieToastDetails.isShow, setShow: function (val) {
                        setSelfieToastDetails({
                            isShow: val,
                            isError: false,
                            msg: "",
                        });
                    }, position: "bottom-center", 
                    // message={toastDetails.msg}
                    customMessage: React.createElement(React.Fragment, null,
                        React.createElement("span", { className: "d-flex justify-content-between" },
                            React.createElement("span", { className: "d-flex" },
                                React.createElement("img", { src: selfieToastDetails.isError
                                        ? failureIcon
                                        : successIcon }),
                                React.createElement("label", { className: "toast-custom-label" }, selfieToastDetails === null || selfieToastDetails === void 0 ? void 0 : selfieToastDetails.msg)),
                            React.createElement("div", { className: "edel-icon" },
                                React.createElement(Edelicon, { className: "edel-icon-close cursor-pointer", onClick: function () {
                                        return setSelfieToastDetails({
                                            isShow: false,
                                            isError: false,
                                            msg: "",
                                        });
                                    } })))), delay: 3000, parentClass: "sidebar-toast-container ".concat(selfieToastDetails.isError ? "error-toast" : "success-toast") })),
                verificationLinkToastDetails && (React.createElement(Toasts, { show: verificationLinkToastDetails.isShow, setShow: function (val) {
                        setVerificationLinkToastDetails({
                            isShow: val,
                            isError: false,
                            msg: "",
                        });
                    }, position: "bottom-center", 
                    // message={toastDetails.msg}
                    customMessage: React.createElement(React.Fragment, null,
                        React.createElement("span", { className: "d-flex justify-content-between" },
                            React.createElement("span", { className: "d-flex" },
                                React.createElement("img", { src: verificationLinkToastDetails.isError
                                        ? failureIcon
                                        : successIcon }),
                                React.createElement("label", { className: "toast-custom-label" }, verificationLinkToastDetails === null || verificationLinkToastDetails === void 0 ? void 0 : verificationLinkToastDetails.msg)),
                            React.createElement("div", { className: "edel-icon" },
                                React.createElement(Edelicon, { className: "edel-icon-close cursor-pointer", onClick: function () {
                                        return setVerificationLinkToastDetails({
                                            isShow: false,
                                            isError: false,
                                            msg: "",
                                        });
                                    } })))), delay: 3000, parentClass: "sidebar-toast-container ".concat(selfieToastDetails.isError ? "error-toast" : "success-toast") })),
                React.createElement("div", { className: "order-book-sidebar-body d-flex flex-column ".concat(loader
                        ? "body-h-single-header-with-footer"
                        : showFooter()
                            ? "body-h-single-header-with-footer"
                            : "body-h-single-header"), ref: sectionRef, onClick: function () {
                        outSideClick();
                    } },
                    errorFoundMain && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "custom-error-state flexCenter" },
                            React.createElement(Errormsg, { image: apiFailure, msg: "Something went Wrong", parentClassName: "DMSansMedium_20_500", parentErrorClassName: "DMSansMedium_20_500", customComp: React.createElement("div", { className: "error-state-button-bar flexCenter" },
                                    React.createElement("p", { className: "DMSanN_13_400" }, "Refresh the page, or try again later."),
                                    React.createElement("button", { className: "align-items-center error-state-button-text", onClick: function () {
                                            getAOPOrderBookSideBar();
                                        } }, "Try Again")) })))),
                    errorFoundMain == false && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "sidebar-body-top-container" },
                            React.createElement("div", { className: "d-flex flex-column primary-orderbook-sidebar-status-box-container mgb-5" },
                                React.createElement("div", { className: "d-flex flex-row justify-content-between" }, ((_g = props === null || props === void 0 ? void 0 : props.selectedRowObj) === null || _g === void 0 ? void 0 : _g.displayStatus) == "-" ? ("-") : (React.createElement(React.Fragment, null,
                                    React.createElement(GenericStatus, { statusText: (_h = props === null || props === void 0 ? void 0 : props.selectedRowObj) === null || _h === void 0 ? void 0 : _h.displayStatus, statusType: (_j = props === null || props === void 0 ? void 0 : props.selectedRowObj) === null || _j === void 0 ? void 0 : _j.status, customIcon: getCustomIcon() })))),
                                loader ? (React.createElement(Common_Shimmer, { number: 3 })) : (React.createElement(React.Fragment, null,
                                    ((_k = props === null || props === void 0 ? void 0 : props.selectedRowObj) === null || _k === void 0 ? void 0 : _k.displayStatus) ==
                                        "QC Rejected" && (React.createElement("div", { className: "status-description rejection-description ".concat((_l = props === null || props === void 0 ? void 0 : props.selectedRowObj) === null || _l === void 0 ? void 0 : _l.status.toLowerCase(), " d-flex flex-column") },
                                        React.createElement("label", { className: "DMsanR_11_400" }, "Your application got rejected due to the following issues:"),
                                        showRejectedDescription())),
                                    React.createElement("label", { className: "status-date DMsanL_12_300" }, (_m = props === null || props === void 0 ? void 0 : props.selectedRowObj) === null || _m === void 0 ? void 0 : _m.statusDate)))),
                            loader ? "" : React.createElement(React.Fragment, null, getOrderTimeline())),
                        React.createElement("div", { className: "sidebar-body-mid-container" },
                            React.createElement("div", { className: "accordion" },
                                React.createElement("div", { className: "accordion-item" },
                                    React.createElement("div", { 
                                        //id="target-accordian-1"
                                        className: activeIndex === 0
                                            ? "accordion-header"
                                            : "accordion-header-collapsed", onClick: function () {
                                            setOpenTimeline(false);
                                            scrollToTop();
                                            togglePanel(0);
                                        } },
                                        React.createElement("span", { className: "d-flex flex-row ".concat(activeIndex === 0
                                                ? "accordion-header-sub"
                                                : "accordion-header-sub-new") },
                                            React.createElement("span", { className: "accordion-header-content" },
                                                React.createElement("img", { src: applicationDetails, alt: "Application Details", className: "header-image1" }),
                                                React.createElement("label", { className: "accordion-header-label DMSanN_16_400" }, "Application Details")),
                                            React.createElement("span", { className: "accordion-header-arrow-icon" }, activeIndex === 0 ? (React.createElement("i", { className: "edel-icon-arrow-up-thin accordian-edel-icon-color" })) : (React.createElement("i", { className: "edel-icon-arrow-down accordian-edel-icon-color" }))))),
                                    activeIndex === 0 && (React.createElement(React.Fragment, null,
                                        " ",
                                        loader ? (React.createElement(Common_Shimmer, { number: 5 })) : (React.createElement("div", { className: "accordion-content" },
                                            React.createElement("ul", { className: "accordian-content-ul" },
                                                React.createElement("li", { className: "accordian-content-li" },
                                                    React.createElement("span", { className: "accordian-content-li-span" },
                                                        React.createElement("label", { className: "  accordian-contenl-li-span-first-label " }, "Lead Id"),
                                                        React.createElement("label", { className: "   accordian-content-second" }, displayDash((_o = aopOrderBookSideBar === null || aopOrderBookSideBar === void 0 ? void 0 : aopOrderBookSideBar.application_details) === null || _o === void 0 ? void 0 : _o.leadid)))),
                                                React.createElement("li", { className: "accordian-content-li" },
                                                    React.createElement("span", { className: "accordian-content-li-span" },
                                                        React.createElement("label", { className: "  accordian-contenl-li-span-first-label " }, "DP Id"),
                                                        React.createElement("label", { className: "   accordian-content-second" }, displayDash((_p = aopOrderBookSideBar === null || aopOrderBookSideBar === void 0 ? void 0 : aopOrderBookSideBar.application_details) === null || _p === void 0 ? void 0 : _p.clientid)))),
                                                React.createElement("li", { className: "accordian-content-li" },
                                                    React.createElement("span", { className: "accordian-content-li-span" },
                                                        React.createElement("label", { className: "  accordian-contenl-li-span-first-label " }, "KYC Status"),
                                                        React.createElement("label", { className: "   accordian-content-second" }, displayDash((_q = aopOrderBookSideBar === null || aopOrderBookSideBar === void 0 ? void 0 : aopOrderBookSideBar.application_details) === null || _q === void 0 ? void 0 : _q.kycstatus)))),
                                                React.createElement("li", { className: "accordian-content-li" },
                                                    React.createElement("span", { className: "accordian-content-li-span" },
                                                        React.createElement("label", { className: "  accordian-contenl-li-span-first-label " }, "Plan"),
                                                        React.createElement("label", { className: "   accordian-content-second" }, displayDash((_r = aopOrderBookSideBar === null || aopOrderBookSideBar === void 0 ? void 0 : aopOrderBookSideBar.application_details) === null || _r === void 0 ? void 0 : _r.plan)))),
                                                React.createElement("li", { className: "accordian-content-li" },
                                                    React.createElement("span", { className: "accordian-content-li-span" },
                                                        React.createElement("label", { className: "  accordian-contenl-li-span-first-label " }, "DP Code"),
                                                        React.createElement("label", { className: "   accordian-content-second" }, displayDash((_s = aopOrderBookSideBar === null || aopOrderBookSideBar === void 0 ? void 0 : aopOrderBookSideBar.application_details) === null || _s === void 0 ? void 0 : _s.dpaccountno)))),
                                                React.createElement("li", { className: "accordian-content-li" },
                                                    React.createElement("span", { className: "accordian-content-li-span" },
                                                        React.createElement("label", { className: "  accordian-contenl-li-span-first-label " }, "DP Client Id"),
                                                        React.createElement("label", { className: "   accordian-content-second" }, displayDash((_t = aopOrderBookSideBar === null || aopOrderBookSideBar === void 0 ? void 0 : aopOrderBookSideBar.application_details) === null || _t === void 0 ? void 0 : _t.clientid)))))))))),
                                React.createElement("div", { className: "accordion-item" },
                                    React.createElement("div", { className: activeIndex === 1
                                            ? "accordion-header"
                                            : "accordion-header-collapsed", ref: targetRef, onClick: function () {
                                            setOpenTimeline(false);
                                            scrollToElement();
                                            if (loader == false)
                                                togglePanel(1);
                                        } },
                                        React.createElement("span", { className: "d-flex flex-row ".concat(activeIndex === 1
                                                ? "accordion-header-sub"
                                                : "accordion-header-sub-new") },
                                            React.createElement("span", { className: "accordion-header-content" },
                                                React.createElement("img", { src: qualityCheck, alt: "Application Details", className: "header-image2" }),
                                                React.createElement("label", { className: "accordion-header-label DMSanN_16_400" }, "Quality Check Details")),
                                            React.createElement("span", { className: "accordion-header-arrow-icon" }, activeIndex === 1 ? (React.createElement("i", { className: "edel-icon-arrow-up-thin accordian-edel-icon-color" })) : (React.createElement("i", { className: "edel-icon-arrow-down accordian-edel-icon-color" }))))),
                                    activeIndex === 1 && (React.createElement("div", { className: "accordion-content" },
                                        React.createElement("ul", { className: "accordian-content-ul" },
                                            React.createElement("li", { className: "accordian-content-li" },
                                                React.createElement("span", { className: "accordian-content-li-span" },
                                                    React.createElement("label", { className: "  accordian-contenl-li-span-first-label " }, "QC Assigned to"),
                                                    React.createElement("label", { className: "   accordian-content-second" }, getQCAssignedTo()))),
                                            React.createElement("li", { className: "accordian-content-li" },
                                                React.createElement("span", { className: "accordian-content-li-span" },
                                                    React.createElement("label", { className: "  accordian-contenl-li-span-first-label " }, "No. Of Rejections"),
                                                    React.createElement("label", { className: "   accordian-content-second" }, displayDash((_u = aopOrderBookSideBar === null || aopOrderBookSideBar === void 0 ? void 0 : aopOrderBookSideBar.quality_check_details) === null || _u === void 0 ? void 0 : _u.no_of_rejections)))))))),
                                React.createElement("div", { className: "accordion-item" },
                                    React.createElement("div", { className: activeIndex === 2
                                            ? "accordion-header"
                                            : "accordion-header-collapsed", onClick: function () {
                                            setOpenTimeline(false);
                                            scrollToBottom();
                                            if (loader == false)
                                                togglePanel(2);
                                        } },
                                        React.createElement("span", { className: "d-flex flex-row ".concat(activeIndex === 2
                                                ? "accordion-header-sub"
                                                : "accordion-header-sub-new") },
                                            React.createElement("span", { className: "accordion-header-content" },
                                                React.createElement("img", { src: customerKYCDetails, alt: "Application Details", className: "header-image3" }),
                                                React.createElement("label", { className: "accordion-header-label DMSanN_16_400" }, "Customer KYC Details")),
                                            React.createElement("span", { className: "accordion-header-arrow-icon" }, activeIndex === 2 ? (React.createElement("i", { className: "edel-icon-arrow-up-thin accordian-edel-icon-color" })) : (React.createElement("i", { className: "edel-icon-arrow-down accordian-edel-icon-color" }))))),
                                    activeIndex === 2 && (React.createElement("div", { className: "accordion-content" },
                                        React.createElement("ul", { className: "accordian-content-ul" },
                                            React.createElement("li", { className: "accordian-content-li" },
                                                React.createElement("span", { className: "accordian-content-li-span" },
                                                    React.createElement("label", { className: "  accordian-contenl-li-span-first-label " }, "KYC Form"),
                                                    React.createElement("label", { className: "   accordian-content-second" }, downloadSpinner ? (React.createElement("span", null,
                                                        React.createElement("div", { className: "action-internal-item displayFlex align-self-start gap-10" },
                                                            React.createElement(Spinner, { animation: "border", variant: "primary", className: "txt_tomatoRed" })))) : (React.createElement(EdButton, { btnTyp: "text-only", disabled: !((_v = aopOrderBookSideBar === null || aopOrderBookSideBar === void 0 ? void 0 : aopOrderBookSideBar.application_details) === null || _v === void 0 ? void 0 : _v.iskycdownloaddisable), onClick: function () {
                                                            getAOPOrderBookKYCDocument();
                                                        }, className: "DMSansNormal_12_400", value: React.createElement("span", { className: "d-flex align-items-center gap-1" },
                                                            React.createElement("span", { className: "text-decoration-underline" }, "Download")) }))))))))))),
                        loader ? "" : React.createElement(React.Fragment, null, React.createElement(AOPOrderbookNeedHelp, null)))))), footer: loader ? undefined : (React.createElement(React.Fragment, null,
                showPopupMenu && getOverLayUIContent(),
                React.createElement("div", { className: "d-flex justify-content-between align-items-center w-100 orderbook__footer__container" },
                    React.createElement(EdButton, { btnTyp: "tomato", value: "Restart Application", className: "ob-footer-btn", onClick: function (e) { return onButtonClick(e); }, disabled: disabledRestartApplication() }),
                    showThreeDots() && (React.createElement("span", { id: (_w = props === null || props === void 0 ? void 0 : props.selectedRowObj) === null || _w === void 0 ? void 0 : _w.accountCode, ref: componentRef, className: "".concat(showPopupMenu
                            ? "edel-icon-cross-bold-small "
                            : "edel-icon-kabab-menu ", " active-menu-three-dots\"\n                       }"), onClick: function (e) {
                            setShowPopupMenu(!showPopupMenu);
                            // setMoreActionPopupConfig({
                            //   containerId: props?.selectedRowObj?.accountCode,
                            //   isShowPopup: true,
                            // });
                        } }))))), openKey: props === null || props === void 0 ? void 0 : props.sideBar, setOpenKey: props === null || props === void 0 ? void 0 : props.setSideBar, arrowClose: true, delay: 10, blurBackground: true })));
};
export default AOPSidebar;
